import axios from 'axios';

const loadAbort = () => {
    return new AbortController();
};

export const getDevelopersEndpoint = (token: string) => {
    const controller = loadAbort();
    return {
        call: (urlService: string) =>
            axios({
                method: 'get',
                url: `${urlService}/pre-sales/v1/admin/developers`,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            }),
        controller,
    };
};

export const getDeveloperDetailsEndpoint = (developerId: string, token: string) => {
    const controller = loadAbort();
    return {
        call: (urlService: string) =>
            axios({
                method: 'get',
                url: `${urlService}/pre-sales/v1/admin/developers/${developerId}`,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            }),
        controller,
    };
};

export const createDeveloperEndpoint = (name: string, description: string, token: string) => {
    const controller = loadAbort();
    return {
        call: (urlService: string) =>
            axios({
                method: 'post',
                url: `${urlService}/pre-sales/v1/admin/developers`,
                data: JSON.stringify({ name, description }),
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            }),
        controller,
    };
};
export const updateDeveloperEndpoint = (developerId: string, name: string, description: string, token: string) => {
    const controller = loadAbort();
    return {
        call: (urlService: string) =>
            axios({
                method: 'put',
                url: `${urlService}/pre-sales/v1/admin/developers/${developerId}`,
                data: JSON.stringify({ name, description }),
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            }),
        controller,
    };
}

export const updateDeveloperAvatarEndpoint = (
    developerId: string,
    form: any,
    token: string,
) => {
    const controller = loadAbort();
    return {
        call: (urlService: string) =>
            axios({
                method: 'put',
                url: `${urlService}/pre-sales/v1/admin/developers/${developerId}/upload-avatar`,
                data: form,
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${token}`,
                },
            }),
        controller,
    };
};